export default __webpack_public_path__ + "static/media/Mulugeta-Kassahun.021453d6.png";